import { FormattedMessage, useIntl } from 'react-intl';

import { EcpServices } from '../ecp-locator.models';
import { IconSizes, IconTypes, Tooltip } from '../../../../common';
import { IconButton } from '../../../../common/icon-button';
import { useStyles } from './ecp-title.styles';

export interface EcpTitleProps {
  ecpService: EcpServices;
  className?: string;
  tooltip?: string;
  tooltipAriaLabel?: string;
}

const SERVICE_TITLE_MAP: Record<EcpServices, string> = {
  [EcpServices.buy]: 'ecp.title.buy',
  [EcpServices.fit]: 'ecp.title.fit',
  [EcpServices.cataract]: 'ecp.title.cataract',
  [EcpServices.cv]: 'ecp.title.cv',
  [EcpServices.aec]: 'ecp.title.aec',
};

const TitleTooltip = ({ text, ariaLabel }: { text: string, ariaLabel: string }): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Tooltip
      placement="bottom"
      title={(
        <p
          data-testid="tooltip-content"
          className={classes.tooltipContent}
        >
          <FormattedMessage id={text} />
        </p>
      )}
      withArrow
      tooltipClass={classes.tooltip}
    >
      <IconButton
        data-testid="tooltip-button"
        aria-label={intl.formatMessage({ id: ariaLabel })}
        iconProps={{
          type: IconTypes.infoBlack,
          size: IconSizes.sm,
        }}
      />
    </Tooltip>
  );
};

export const EcpTitle = ({ ecpService }: EcpTitleProps): JSX.Element => {
  const intl = useIntl();
  const titleId = SERVICE_TITLE_MAP[ecpService];
  const classes = useStyles();

  return (
    <h1
      className={classes.title}
      data-testid="ecp-title"
    >
      {intl.formatMessage({ id: titleId })}
      {ecpService === EcpServices.cataract && (
        <TitleTooltip
          text="ecp.services.cataract.tooltip"
          ariaLabel="ecp.services.cataract.ariaLabel"
        />
      )}
    </h1>
  );
};
